import { atom } from "recoil";
import { persistAtom } from "./persistAtom";

const programViewModeAtom = atom({
  key: "programViewMode",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export default programViewModeAtom;
